import { render } from "./TrainingsBlock.vue?vue&type=template&id=28c1b702&scoped=true"
import script from "./TrainingsBlock.vue?vue&type=script&lang=js"
export * from "./TrainingsBlock.vue?vue&type=script&lang=js"

import "./TrainingsBlock.vue?vue&type=style&index=0&id=28c1b702&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c1b702"]])

export default __exports__